<script setup lang="ts">
const verticalBlueBookStyles = useScrollTransformedStyle({
  multiplierX: 0.15,
  multiplierY: 0.35,
  rotateMultiplier: -0.05,
})

const secondStackStyle = useScrollTransformedStyle({
  multiplierX: 0.15,
  multiplierY: 0.45,
  rotateMultiplier: 0.06,
})

const firstStackStyle = useScrollTransformedStyle({
  multiplierX: -0.15,
  multiplierY: 0.45,
  rotateMultiplier: 0.06,
})
</script>

<template>
  <svg class="w-80" width="400" height="400" viewBox="0 0 400 400" overflow="visible" fill="none" xmlns="http://www.w3.org/2000/svg">

    <g class="vertical-books" :style="verticalBlueBookStyles">
      <path d="M306.86 146.755H229.439V279.719H306.86V146.755Z" fill="#A3B5FE" />
      <path d="M306.859 146.755H305.299V279.719H306.859V146.755Z" fill="#F8F8F8" />
      <path d="M331.438 146.755H306.858V279.719H331.438V146.755Z" fill="#A3B5FE" />
      <path d="M356.017 164.963H331.438V279.718H356.017V164.963Z" fill="#00173B" />
    </g>

    <g class="first-stack" :style="firstStackStyle">
      <g class="second-book">
        <path d="M252.302 252.767H156.594V214.909H252.302C262.107 214.909 270.078 222.879 270.078 232.685V234.992C270.078 244.797 262.107 252.767 252.302 252.767Z" fill="#102B09" />
        <path d="M44.0003 218.265L171.72 218.265V214.909L44.0003 214.909V218.265Z" fill="#102B09" />
        <path d="M44.0003 252.767L171.72 252.767V249.411L44.0003 249.411V252.767Z" fill="#102B09" />
        <path d="M167.722 249.425L43.9875 249.425V218.344L167.722 218.344C176.309 218.331 183.27 225.304 183.27 233.878C183.27 242.464 176.309 249.425 167.722 249.425Z" fill="#F8F8F8" />
        <path d="M155.794 229.014H44.1851" stroke="#00173B" stroke-width="0.629227" stroke-miterlimit="10" />
        <path d="M148.359 239.226H171.365" stroke="#00173B" stroke-width="0.629227" stroke-miterlimit="10" />
      </g>

      <g class="first-book">
        <path d="M256.941 252.518H100.25V255.874H256.941V252.518Z" fill="#DAFEA4" />
        <path d="M256.941 276.875H100.25V280.231H256.941V276.875Z" fill="#DAFEA4" />
        <path d="M76.5097 252.781H100.093C100.184 252.781 100.25 252.846 100.25 252.938V280.073C100.25 280.165 100.184 280.231 100.093 280.231H76.5097C68.9327 280.231 62.7847 274.083 62.7847 266.506C62.7847 258.929 68.9327 252.781 76.5097 252.781Z" fill="#DAFEA4" />
        <path d="M250.741 255.874H156.58V276.875H250.741V255.874Z" fill="#F8F8F8" />
        <path d="M77.5857 255.874H156.58V276.993H77.5333C71.726 276.993 67.0068 272.273 67.0068 266.466C67.0068 260.62 71.7523 255.874 77.5988 255.874H77.5857Z" fill="#EFEFEF" />
      </g>
    </g>

    <g class="second-stack" :style="secondStackStyle">
      <g class="fourth-book">
        <path d="M189.548 142.456H113.464V145.812H189.548V142.456Z" fill="#CFFDFF" />
        <path d="M189.549 178.178H113.465V181.533H189.549V178.178Z" fill="#CFFDFF" />
        <path d="M189.548 142.456H252.89C263.679 142.456 272.435 151.213 272.435 162.001C272.435 172.79 263.679 181.547 252.89 181.547H189.548V142.469V142.456Z" fill="#CFFDFF" />
        <path d="M116.638 145.811H204.611C213.499 145.811 220.709 153.021 220.709 161.909V162.067C220.709 170.954 213.499 178.164 204.611 178.164H116.638V145.798V145.811Z" fill="#F8F8F8" />
        <path d="M119.431 157.177H142.45" stroke="#00173B" stroke-width="0.629227" stroke-miterlimit="10" />
        <path d="M136.877 164.269H207.783" stroke="#00173B" stroke-width="0.629227" stroke-miterlimit="10" />
      </g>

      <g class="third-book">
        <path d="M71.8439 181.533H168.64V214.909H71.8439C62.6283 214.909 55.1562 207.437 55.1562 198.221C55.1562 189.005 62.6283 181.533 71.8439 181.533Z" fill="#00173B" />
        <path d="M272.317 181.534H153.498V184.889H272.317V181.534Z" fill="#00173B" />
        <path d="M272.317 211.553H153.498V214.909H272.317V211.553Z" fill="#00173B" />
        <path d="M166.83 184.902H267.309V211.566H166.83C159.476 211.566 153.498 205.588 153.498 198.234C153.498 190.88 159.476 184.902 166.83 184.902Z" fill="#F8F8F8" />
        <path d="M199.837 198.235H202.499H206.143H209.774V198.929V213.769L206.143 217.544L202.499 213.769V198.929H199.837V198.235Z" fill="#DAFEA4" />
      </g>
    </g>

    <g class="top-green" :style="firstStackStyle">
      <path d="M248.001 120H180.071V123.356H248.001V120Z" fill="#DAFEA4" />
      <path d="M248.001 139.1H180.071V142.456H248.001V139.1Z" fill="#DAFEA4" />
      <path d="M180.071 142.456H119.088C112.901 142.456 107.867 137.422 107.867 131.221C107.867 125.021 112.901 119.987 119.101 119.987H180.084V142.456H180.071Z" fill="#DAFEA4" />
      <path d="M245.838 139.1H177.593C173.254 139.1 169.728 135.574 169.728 131.235C169.728 126.895 173.254 123.369 177.593 123.369L245.838 123.369V139.1Z" fill="#F8F8F8" />
      <path d="M219.49 127.092H222.164H225.795H229.439V127.774V142.626L225.795 146.401L222.164 142.626V127.774H219.49V127.092Z" fill="#00173B" />
    </g>

  </svg>
</template>
